module.exports = __webpack_public_path__ + "img/lover-card.64946dfd.gif";